import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import inventoryDefaultAPI from '../../api';

const getEquipCounts = async ({ params }) => {
  try {
    const response = await inventoryDefaultAPI.get(`counts`, {
      params,
    });
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getEquipCounts;
